// extracted by mini-css-extract-plugin
export default {"search":"Search_search__sW3Qb","searchBtn":"Search_searchBtn__LICYm","result":"Search_result__K00cB","loader":"Search_loader__rQlRQ"};